module.exports = __webpack_public_path__ + "assets/img/function5.3f0f0df3.png";